/* ============
 * 10 Best clients
 * ============
 *
 * This is horizontal bar.
 */
import { mapGetters } from 'vuex';
import userWidgetsService from './../../../services/widgets';
import BarChart from './../../widgetsChart/horizontalBar/horizontalBar.vue';

export default {
  components: {
    BarChart,
  },

  data() {
    return {
      options: {
        plugins: {
          datalabels: {
            display: true,
            align: 'center',
            anchor: 'center',
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: {
            left: 0, right: 0, top: 0, bottom: 0,
          },
        },
        legend: {
          display: false,
          position: 'left',
          labels: {
            boxWidth: 0,
          },
        },
        tooltips: {
          enabled: false,
        },
      },
      chartdata: {
        labels: [],
        datasets: [
          {
            backgroundColor: ['#3B82F6', '#8B5CF6', '#3B82F6', '#8B5CF6', '#3B82F6', '#8B5CF6', '#3B82F6', '#8B5CF6', '#3B82F6', '#8B5CF6'],
            data: [],
          },
        ],
      },
      loaded: false,
      filterBy: [
        { label: this.$t('static.widgets.soldProduct.filters.last3Months'), value: 'last_3_months' },
        { label: this.$t('static.widgets.soldProduct.filters.last6Months'), value: 'last_6_months' },
        { label: this.$t('static.widgets.soldProduct.filters.thisYear'), value: 'this_year' },
      ],
      filterBySelected: 'last_3_months',
      monthNumber: 3,
      monthStart: 1,
    };
  },

  computed: {
    ...mapGetters({
      bestClientsWidgets: 'bestClientsWidgets',
    }),
  },

  watch: {
    bestClientsWidgets(bestClientsWidgets) {
      this.topClients(bestClientsWidgets.items);
    },
  },

  methods: {
    updateChart(value) {
      this.monthStart = 1;
      if (value === 'last_3_months') {
        this.monthNumber = 3;
      } else if (value === 'last_6_months') {
        this.monthNumber = 6;
      } else {
        this.monthStart = 0;
        this.monthNumber = parseInt(new Date().getMonth());
      }
      this.initializeWidgets(value);
    },

    topClients(bestClientsWidgets) {
      const self = this;
      this.chartdata.labels = [];
      this.chartdata.datasets[0].data = [];
      const values = Object.entries(bestClientsWidgets);
      for (const value of values) {
        self.chartdata.labels.push(`${value[0]} (${value[1]})`);
        self.chartdata.datasets[0].data.push(value[1]);
      }
      this.loaded = true;
    },
    initializeWidgets(filter) {
      this.loaded = false;
      Promise.all([
        userWidgetsService.fetchBestClientsWidgets(filter),
      ]).then(() => {
        this.topClients(this.bestClientsWidgets.items);
      });
    },
  },

  created() {
    this.initializeWidgets();
  },

};



// WEBPACK FOOTER //
// ./src/app/components/widgets/topClients/topClients.js